import * as React from 'react'
const CheckmarkIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path d="M4.92 11.5H4.7l-.19-.13-3.35-3.48A.54.54 0 011 7.51.53.53 0 011.53 7a.47.47 0 01.33 0l3.06 3.14 7.19-7.52a.57.57 0 01.18-.12h.4l.17.12a.32.32 0 01.1.17.45.45 0 010 .42.32.32 0 01-.1.17l-7.54 8a.67.67 0 01-.4.12z" className="-primary-color" fill="#a5aab8"/>
    </svg>
    
  )
}

export default CheckmarkIcon